<!--
 * @Description  : 订单管理
 * @Author       : git config user.sname
 * @Date         : 2025-12-27 13:41:07
 * @LastEditors  : git config user.sname
 * @LastEditTime : 2025-12-27 13:41:34
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\order-management\home.vue
-->

<template>
	<transition name="fade"
				mode="out-in">
		<!-- 用做缓存页面 -->
		<keep-alive :include="cachedViews">
			<router-view :key="key" />
		</keep-alive>
	</transition>
</template>

<script>
import { mapState } from "vuex";

export default {
	name: 'order-management',
	data() {
		return {}
	},
	methods: {},
	computed: {
		...mapState('tags', {
			cachedViews: state => state.cacheTags
		}),
		key() {
			// console.log(this.$route.name)
			return this.$route.name
		}
	}
}
</script>

<style scoped lang="less">
</style>